import { Select, Space } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import trans from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";
import { useGetAllformsQuery } from "../../../Redux/service/Forms/Form";
import { useGetFormsByUserQuery } from "../../../Redux/service/Permissions/FormsPermissions";

export default function FormsMultiInput({
	label,
	styling,
	handleLink,
	handleUnLink,
	userId,
	type,
}) {
	const { isLinking } = useContext(popupcontext);
	const [isOpen, setIsOpen] = useState(false);
	const [selectedForms, setSelectedForms] = useState([]);
	const [groups, setGroups] = useState([]);

	// All available (active) forms -> dropdown options (from backend2)
	let { data: AllForms, refetch: AllFormsRefetch } = useGetAllformsQuery({
		page: 1,
		limit: 10000,
		isActive: true,
	});

	// Forms already linked to this user -> selected tags (from backend1)
	let { data: UserForms, refetch: UserFormsRefetch } = useGetFormsByUserQuery(
		userId,
		{ skip: !userId }
	);

	const handleDropdownVisibleChange = (visible) => {
		setIsOpen(visible);
	};

	const isFirstMount = useRef(true);
	useEffect(() => {
		if (isFirstMount.current || AllFormsRefetch) {
			setGroups(
				AllForms?.data?.map((i) => ({
					value: i.id,
					label: i.name,
				}))
			);
		}
		isFirstMount.current = false;
	}, [AllForms, AllFormsRefetch]);

	useEffect(() => {
		if (UserForms) {
			setSelectedForms(UserForms?.data?.map((i) => i.id));
		}
	}, [UserForms]);

	useEffect(() => {
		if (isLinking) {
			UserFormsRefetch();
		}
	}, [isLinking, UserFormsRefetch]);

	return (
		<div className={styling}>
			{label && <div className="mult-input-label">{trans(label)}</div>}
			<Space
				style={{
					width: "100%",
					borderColor: "red",
				}}
				direction="vertical"
			>
				<Select
					mode="multiple"
					style={{
						width: "100%",
						marginTop: "8px",
						borderColor: "red",
					}}
					maxTagCount={"responsive"}
					placeholder={trans("Please select")}
					onSelect={(value) => {
						setSelectedForms((prev) => [...prev, value]);
						handleLink(value, "form", "Forms");
					}}
					onDeselect={(value) => {
						setSelectedForms((prev) => prev.filter((v) => v !== value));
						handleUnLink(value, "form", "Forms");
					}}
					value={selectedForms || ""}
					options={groups}
					open={isOpen}
					allowClear
					onDropdownVisibleChange={handleDropdownVisibleChange}
					filterOption={(input, option) =>
						option.label.toLowerCase().includes(input.toLowerCase())
					}
				/>
			</Space>
		</div>
	);
}
